import axios from "axios";
import { API_URL, API_URL_SQL } from "../utils/Constant";

export const uploadCountSheets = async (rows) => {
  try {
    let response = await axios.post(`${API_URL}/uploadcountsheets/`, rows);
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data, status_code: response.status };
  } catch (e) {
    const message = "Something went wrong";
    return {
      success: false, message, error_message: e.message, status_code: e.response.status,
    };
  }
};

export const getGenerateSheet = async (
  source_date,
  target_date,
  selectedDay,
  selectedCategory,
) => {
  const x = selectedDay;
  if (x === "Rush_1-day" || x === "Rush" || x === "Pending" || x === "Retest" || x === "Plate") {
    try {
      const response = await axios.get(`${API_URL}/generatecountsheets/`, {
        params: {
          target_date: target_date || "",
          category: x || "",
          input: selectedCategory,
        },
      });

      const data = await response.data;
      return { success: true, ...data };
    } catch (e) {
      const message = "Something went wrong.";
      return { success: false, message };
    }
  } else {
    try {
      const response = await axios.get(`${API_URL}/generatecountsheets/`, {
        params: {
          source_date: source_date || "",
          target_date: target_date || "",
          input: selectedCategory,
        },
      });

      const data = await response.data;
      return { success: true, ...data };
    } catch (e) {
      const message = "Something went wrong.";
      return { success: false, message };
    }
  }
};

export const uploadCountReChecks = async (payload) => {
  try {
    let response = await axios.post(`${API_URL}/rechecks/`, {
      count: "rechecks",
      list: payload,
    });
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data, status_code: response.status };
  } catch (e) {
    const message = "Something went wrong.";
    return {
      success: false, message, error_message: e.message, status_code: e.response.status,
    };
  }
};

export const getDynamicSheet = async (date) => {
  try {
    let response = await axios.get(`${API_URL}/getworkorder/`, {
      params: { date },
    });

    let data = await response.data;

    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }

    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const uploadDynamicSheet = async (category, list) => {
  try {
    let response = await axios.post(`${API_URL}/dynamicsheets/`, {
      category,
      list,
    });

    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const uploadExcelFile = async (rows) => {
  try {
    let response = await axios.post(`${API_URL}/dynamicupload/`, rows);

    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

export const uploadDynamicCountReChecks = async (payload) => {
  try {
    let response = await axios.post(`${API_URL}/dynamicrecheck/`, {
      count: "rechecks",
      list: payload,
    });
    let data = await response.data;
    if (data && data.length > 0) {
      response = data[0];
      data = {
        list: response.result,
      };
    }
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

/**
 * When QR code is scanned, fetch samples for the modal. Omit `counts` for Clean/TNTC so rows load without a bulk count update; users submit via `upload_single_count`.
 * @param {Object} payload { wo_id, genista_id, petrifilm, petrifilm_code, df, counts }
 * @returns {Object} { success, message, result } result is a list of samples
 */
export const scanPetrifilm = async (params) => {
  try {
    const response = await axios.get(`${API_URL}/micro_scanner/`, { params });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Submit counts for sample.
 * @param {Object} payload { wo_id, genista_id, analysis, petrifilm, df, counts, recheck, mapping, wo, sample_id, test_in_sample_id }
 * @returns {Object} { success, message, result } result is the sample object
 */
export const uploadPetrifilmSingleCount = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/upload_single_count/`, payload);

    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Persist micro scanner petrifilm image path after manual upload (S3 path from presigned upload).
 * @param {Object} payload { wo_id, genista_id, petrifilm, petrifilm_code, df, user_id, img_path }
 */
export const addUserMicroImage = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/add_user_micro_image/`, payload);
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Delete the current petrifilm mapping for the current analysis
 * @param {Object} payload { wo_id, genista_id, analysis, petrifilm, df, counts, recheck, mapping, wo, sample_id, test_in_sample_id }
 * @returns {Object} { success, message, result } result is the sample object
 */
export const deletePetrifilmMapping = async (payload) => {
  try {
    const response = await axios.delete(`${API_URL}/upload_single_count/`, { data: payload });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Get pending tests
 * @returns {Object} { success, message, result } result is a list of tests
 */
export const getPending = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/pending_micro/`, { params, signal });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * Get samples for which hierarchy has failed
 * @returns {Object} { success, message, result } result is a list of samples
 */
export const getResolveHierarchySamples = async () => {
  try {
    const response = await axios.get(`${API_URL}/resolve_hierarchy_fail/`);
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Post resolve hierarchy samples
 * @param {Array} samples list of samples
 * @returns {Object} { success, message, result } result is a list of samples
 */
export const postResolveHierarchySamples = async (samples) => {
  try {
    const response = await axios.post(`${API_URL}/resolve_hierarchy_fail/`, {
      samples,
    });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Get Micro Hold Tests
 * @returns {Object} { success, message, result } result is a list of tests
 */
export const getMicroHold = async (signal) => {
  try {
    const response = await axios.get(`${API_URL}/hold_micro/`, { signal });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * Get Micro Hold Tests
 * @returns {Object} { success, message, result } result is a list of tests
 */
export const resolveMicroHold = async (payload) => {
  try {
    const response = await axios.post(`${API_URL}/hold_micro/`, payload);
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", status_code: e?.status_code ?? 400 };
  }
};

/**
 * Get Resolve
 * @returns {Object} { success, message, result } result is a list of tests
 */
export const getResolvedHistory = async (payload) => {
  const {
    search_value,
    action_taken,
    action_date,
    signal,
  } = payload;
  try {
    const response = await axios.get(`${API_URL}/microactions/?search=${search_value}&action_taken=${action_taken}&action_date=${action_date}`, { signal });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};

/**
 * Update TNTC samples
 * @returns {Object} { success, message }
 */
export const notifyTntc = async () => {
  try {
    const response = await axios.get(`${API_URL}/notify_tntc/`);
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong." };
  }
};

/**
 * Migrate results
 * @returns {Object} { success, message }
 */
export const migrateResults = async (workorder_id_list = []) => {
  try {
    const response = await axios.post(`${API_URL_SQL}/migrate_results/`, { workorder_id_list });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", data: e.response?.data };
  }
};

/**
 * Fetch Micro Queue Data
 * @param {*} params { date: MM/DD/YY }
 * @param {*} signal
 * @returns
 */
export const fetchMicroQueueData = async (params, signal = null) => {
  try {
    const response = await axios.get(`${API_URL}/spcr_micro_results/`, { params, signal });
    return { success: true, ...response.data };
  } catch (e) {
    return { success: false, message: e.response?.data?.message || "Something went wrong.", canceled: e.code === "ERR_CANCELED" };
  }
};
